import { BucketHeader } from "../BucketHeader/BucketHeader";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../../../features/theme/use-theme";
import { Elements } from "@stripe/react-stripe-js";
import StripeModal from "../Stripe";
import { loadStripe } from "@stripe/stripe-js";
import ComputingAPI from "../../../API/computing";
import { useSelector } from "react-redux";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const buttonLeft = (
  <svg
    width="46"
    height="53"
    viewBox="0 0 46 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="0.76001"
      width="44"
      height="50.88"
      rx="16"
      stroke="black"
    />
    <path
      d="M26 32.6507C26 32.9078 25.9026 33.1544 25.7293 33.3361C25.556 33.5179 25.3209 33.62 25.0758 33.62C24.8306 33.62 24.5956 33.5179 24.4222 33.3361L18.2714 26.8854C18.1854 26.7955 18.1171 26.6887 18.0705 26.5711C18.024 26.4535 18 26.3274 18 26.2C18 26.0727 18.024 25.9466 18.0705 25.829C18.1171 25.7114 18.1854 25.6045 18.2714 25.5146L24.4222 19.0639C24.5956 18.8822 24.8306 18.78 25.0758 18.78C25.3209 18.78 25.556 18.8822 25.7293 19.0639C25.9026 19.2457 26 19.4922 26 19.7493C26 20.0064 25.9026 20.2529 25.7293 20.4347L20.2327 26.1992L25.7293 31.9654C25.9026 32.1471 26 32.3937 26 32.6507Z"
      fill="#23232D"
    />
  </svg>
);

const buttonRight = (
  <svg
    width="46"
    height="53"
    viewBox="0 0 46 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="0.76001"
      width="44"
      height="50.88"
      rx="16"
      stroke="black"
    />
    <path
      d="M21.1633 33.5282C20.9872 33.7149 20.7483 33.8198 20.4992 33.8198C20.2502 33.8198 20.0113 33.7149 19.8352 33.5282C19.6591 33.3416 19.5601 33.0883 19.5601 32.8243C19.5601 32.5603 19.6591 32.3071 19.8352 32.1204L25.4219 26.2002L19.8367 20.2782C19.7495 20.1858 19.6804 20.0761 19.6332 19.9553C19.586 19.8345 19.5617 19.7051 19.5617 19.5743C19.5617 19.4436 19.586 19.3142 19.6332 19.1934C19.6804 19.0726 19.7495 18.9629 19.8367 18.8704C19.924 18.778 20.0275 18.7047 20.1414 18.6546C20.2554 18.6046 20.3775 18.5789 20.5008 18.5789C20.6241 18.5789 20.7463 18.6046 20.8602 18.6546C20.9741 18.7047 21.0777 18.778 21.1649 18.8704L27.4149 25.4954C27.5022 25.5879 27.5714 25.6976 27.6186 25.8185C27.6658 25.9393 27.69 26.0689 27.6898 26.1997C27.6897 26.3305 27.6652 26.4599 27.6177 26.5807C27.5703 26.7014 27.5008 26.811 27.4133 26.9032L21.1633 33.5282Z"
      fill="#23232D"
    />
  </svg>
);

export const Billing = () => {
  const [theme] = useTheme();
  const [showPaymentModal, setShowPaymentModel] = useState(false);
  const { email } = useSelector((state) => state.verifyUser);
  const [cardDetail, setCardDetail] = useState(null);

  const getCardDetail = async () => {
    const res = await ComputingAPI.getMyCard(email);
    if (res?.status === 200 && res?.data?.data) {
      setCardDetail(res?.data?.data);
    }
  };

  useEffect(() => {
    getCardDetail();
  }, []);

  return (
    <>
      <div
        className={`text-black w-full h-full px-[40px] flex items-center flex-col max-md:px-[20px] ${
          theme === "dark" ? "bg-[#1B1F27]" : ""
        }`}
      >
        <BucketHeader />
        <Link
          to="https://billing.stripe.com/p/login/3csbIK50race3yoeUU"
          className={`${theme === "dark" ? "text-[#92929D]" : "text-black"}`}
        >
          To choose your billing.{" "}
          <span
            className={`underline font-[600] ${
              theme === "dark" ? "text-white" : "text-black"
            }`}
          >
            Click this link
          </span>
        </Link>
        <br />
        <div
          className={`w-full flex justify-between mb-[18px] max-sm:flex-col max-sm:items-start ${
            theme === "dark" ? "text-[#92929D]" : ""
          }`}
        >
          {cardDetail && (
            <p>
              <strong>{cardDetail?.cardBrand}</strong>{" "}
              ending with {cardDetail?.last4}, <strong>exp</strong>:{" "}
              {cardDetail?.expMonth}/{cardDetail?.expYear}
            </p>
          )}
          <button
            className="text-[#797979] font-[600] p-[10px] rounded-md border-[1px] border-solid"
            type="button"
            onClick={() => setShowPaymentModel(true)}
          >
            Update/Add new Payment Method
          </button>
        </div>
      </div>
      {showPaymentModal && (
        <Elements
          stripe={stripePromise}
          options={{
            appearance: {
              theme: "stripe",
            },
          }}
        >
          <StripeModal
            theme={theme}
            email={email}
            getCardDetail={getCardDetail}
            onClose={() => setShowPaymentModel(false)}
          />
        </Elements>
      )}
    </>
  );
};
